let myObject = {
  customerid: "XM",
  customername: "X-Microwave",
  objectid: "",
  objectname: "",
  viewer: {
    camera: {
      position: "0,8,0",
      fov: 75,
      near: 0.1,
      far: 1000,
    },
    renderer: {
      antialias: true,
      shadowMap: true,
      physicallyCorrectLights: true,
    },
    controls: {
      enableRotate: false,
      enableDamping: false,
      rotateSpeed: 0.5,
      enableZoom: true,
      smoothZoom: true,
      enablePan: true,
      dampFactor: 0.25,
    },
    canvas: {
      canvasDomElement: document.getElementById("modelCanvas"),
    },
    environment: {
      px: "https://viewer-dev.zipcpq.com/textures/Standard-Cube-Map/px.png",
      nx: "https://viewer-dev.zipcpq.com/textures/Standard-Cube-Map/nx.png",
      py: "https://viewer-dev.zipcpq.com/textures/Standard-Cube-Map/py.png",
      ny: "https://viewer-dev.zipcpq.com/textures/Standard-Cube-Map/ny.png",
      pz: "https://viewer-dev.zipcpq.com/textures/Standard-Cube-Map/pz.png",
      nz: "https://viewer-dev.zipcpq.com/textures/Standard-Cube-Map/nz.png",
    },
    model: {
      path: "https://viewer-dev.zipcpq.com/conwaymachine/imgs/stupnik-nomat.glb",
      type: "glbModel",
    },
  },
  materialmapping: {
    type: "color",
    colorschema: "hex",
    mapping: {
      "#1270255": {
        color: "#a6a9a9",
        metalness: 1,
        roughness: 0.285,
        materialname: "metal",
      },
    },
  },
};
let myShape = {
  shape: {
    height: "x",
    width: "y",
    textureImg: "link",
  },
  connectionPoint: {
    name: "name",
    x: "valueForXPosition",
    y: "valueForYPosition",
    z: "null",
  },
};
window.myObject = myObject;
const parentWindow = window.opener || window.parent || window;
export default myObject;
